import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static values = {
    data: Array,
    positive: { type: Boolean, default: true }
  }

  connect() {
    const labels = this.dataValue.map((item) => item.month)
    const values = this.dataValue.map((item) => Math.round(item.amount_cents) / 100)
    const positiveColor = "#198754"
    const negativeColor = "#dc3545"
    const color = this.positiveValue ? positiveColor : negativeColor
    const brl = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" })

    this.chart = new ApexCharts(this.element, {
      chart: {
        type: "area",
        height: "100%",
        width: "100%",
        sparkline: { enabled: true },
        animations: { enabled: true, easing: "easeinout", speed: 450 },
        toolbar: { show: false },
        zoom: { enabled: false }
      },
      series: [{ data: values }],
      labels,
      colors: [color],
      plotOptions: {
        area: { fillTo: "end" }
      },
      stroke: {
        curve: "smooth",
        width: 1,
        lineCap: "round"
      },
      markers: {
        size: 0, 
        colors: [ color ],
        strokeColors: 'var(--color-base-100)',
        strokeWidth: 1,
        hover: { size: 4 }
      },      
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 0,
          opacityFrom: 0.35,
          opacityTo: 0.10,
          stops: [0, 95]
        }
      },
      grid: {
        padding: { top: 8, right: 0, bottom: 0, left: 0 }
      },
      tooltip: {
        marker: { show: false },
        x: { show: false },
        custom: ({ dataPointIndex }) => {
          const value = values[dataPointIndex]
          const valueColor = value >= 0 ? 'var(--color-success)' : 'var(--color-error)'
          const formatted = `${value > 0 ? "+" : ""}${brl.format(value)}`

          return `<div class="shadow-lg" style="padding:7px 10px;font-size:12px;line-height:1.5;background:var(--color-base-100);border:1px solid var(--color-base-300);color:var(--color-base-content);border-radius:var(--radius-box);box-shadow:0 8px 22px rgba(0,0,0,.08)">` +
            `<div class="mb-1" style="var(--color-base-content)">${labels[dataPointIndex]}</div>` +
            `<div style="font-weight:600;color:${valueColor}">${formatted}</div>` +
            `</div>`
        }
      }
    })

    this.chart.render()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
